// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"378":"History","564":"Bind","753":"Latest"}[chunkId] || chunkId) + "." + {"309":"035b8b67","370":"743057c6","378":"f9d1826e","564":"2e2b4105","753":"42509893","826":"35c16d11","933":"939c8bc0","937":"016e57b3"}[chunkId] + ".css";
};